import React, { useCallback, useContext } from 'react'
import { rootStoreContext } from '@app/components/App'
import { observer } from 'mobx-react-lite'

export const HelpPane = observer(() => {
  const rootStore = useContext(rootStoreContext)
  const close = useCallback(() => {
    rootStore.helpOpen = false
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [rootStore.helpOpen])

  return (
    <div
      className="bg-gray-100 fixed left-0 top-0 w-full h-full z-40 flex justify-between"
      onClick={e => {
        if (e.target === e.currentTarget) {
          close()
        }
      }}
    >
      <style>{`body { overflow: hidden }`}</style>
      <div className="lg:max-w-6xl lg:mx-auto bg-white lg:shadow pb-4 lg:my-4 w-full lg:w-128 flex flex-col">
        <div className="flex-shrink-0 text-2xl text-charcoal px-8 pt-8 pb-2 flex justify-between font-semibold">
          <span>How to use</span>
          <span
            className="cursor-pointer hover:text-blue-600 text-xl font-bold self-center"
            onClick={close}
          >
            ✕
          </span>
        </div>
        <div className="overflow-y-auto pt-4">
          <p className="text-charcoal px-8 mb-10">
            Explore Formula One lap times, qualifying times, and pit stop times.
            For each race on the current schedule, you can view previous
            years&apos; data and select a driver to see their lap times over the
            years.
          </p>
          <div className="mb-10">
            <h3 className="text-center text-sm uppercase text-gray-600 font-normal">
              Choose a race
            </h3>
            <img
              className="border border-gray-500 mx-auto max-w-64"
              src="/static/f1times/data/race.png"
            />
          </div>
          <div className="mb-10">
            <h3 className="text-center text-sm uppercase text-gray-600 font-normal">
              Choose a year
            </h3>
            <img
              className="border border-gray-500 mx-auto max-w-64"
              src="/static/f1times/data/year.png"
            />
          </div>
          <div className="mb-10">
            <h3 className="text-center text-sm uppercase text-gray-600 font-normal">
              Select a lap
            </h3>
            <img
              className="border border-gray-500 mx-auto max-w-64"
              src="/static/f1times/data/lap.png"
            />
          </div>
          <div className="mb-10">
            <h3 className="text-center text-sm uppercase text-gray-600 font-normal">
              Select a driver
            </h3>
            <img
              className="border border-gray-500 mx-auto max-w-64"
              src="/static/f1times/data/driver.png"
            />
          </div>
          <div className="text-center text-charcoal mt-12 italic text-sm">
            Data sourced from the{' '}
            <a
              className="text-blue-700"
              href="http://www.ergast.com/mrd"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ergast Developer API
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  )
})
